import { render } from "./UserAuth.vue?vue&type=template&id=05998e14&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=05998e14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05998e14"

export default script